import { useGetTrustLevelsQuery } from '../api';
import { formatTrustLevel } from '../utils/formatTrustLevel';

interface IOption {
  id: string;
  label: string;
}

interface IResult {
  options: IOption[];
  isLoading: boolean;
}

export const useTrustLevelsOptions = (): IResult => {
  const { data, isLoading } = useGetTrustLevelsQuery();

  const options: IOption[] = (data ?? []).map(level => ({
    id: String(level.id),
    label: formatTrustLevel(level),
  }));

  return { options, isLoading };
};
